var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".check-circle{fill:#1d2340;}")),React.createElement("path",{"className":"check-circle","d":"M16.563,8.563a8,8,0,1,1-8-8A8,8,0,0,1,16.563,8.563ZM7.637,12.8l5.935-5.935a.516.516,0,0,0,0-.73l-.73-.73a.516.516,0,0,0-.73,0L7.272,10.244l-2.26-2.26a.516.516,0,0,0-.73,0l-.73.73a.516.516,0,0,0,0,.73L6.907,12.8a.516.516,0,0,0,.73,0Z","transform":"translate(-0.563 -0.563)","key":1})]);
}

CheckCircle.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
